"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uuid = _interopRequireDefault(require("uuid"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var EditableCell = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(EditableCell, _PureComponent);
  var _super = _createSuper(EditableCell);
  function EditableCell(props) {
    var _this;
    (0, _classCallCheck2.default)(this, EditableCell);
    _this = _super.call(this, props);
    _this.onEdit = _this.onEdit.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  /**
   * Edit this cell's row
   */
  (0, _createClass2.default)(EditableCell, [{
    key: "onEdit",
    value: function onEdit() {
      this.props.onEdit(this.props.row);
    }
  }, {
    key: "renderCustomRowAction",
    value: function renderCustomRowAction() {
      var _this$props = this.props,
        row = _this$props.row,
        customRowAction = _this$props.customRowAction;
      if (row.rowType === null || row.rowType === undefined || row.rowType === '' || customRowAction[row.rowType] === undefined) {
        return customRowAction.defaultAction.map(function (element) {
          return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({}, element, {
            key: _uuid.default.v4(),
            type: "button",
            className: element.btnClass,
            onClick: function onClick(e) {
              // prevents propagation of the click event to Cell
              e.stopPropagation();
              element.onClick(row);
            }
          }), /*#__PURE__*/_react.default.createElement("i", {
            className: element.iconClass,
            style: {
              '--color': element.iconColor
            }
          }));
        });
      }
      return customRowAction[row.rowType].map(function (element) {
        return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({}, element, {
          key: _uuid.default.v4(),
          type: "button",
          className: element.btnClass,
          onClick: function onClick(e) {
            // prevents propagation of the click event to Cell
            e.stopPropagation();
            element.onClick(row);
          }
        }), /*#__PURE__*/_react.default.createElement("i", {
          className: element.iconClass,
          style: {
            '--color': element.iconColor
          }
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        cell = _this$props2.cell,
        formatter = _this$props2.formatter,
        row = _this$props2.row,
        listMode = _this$props2.listMode,
        customRowAction = _this$props2.customRowAction;
      var icon = 'fas fa-pencil-alt';
      if (cell && cell.permission === listMode.VIEW) {
        icon = 'fas fa-eye';
      }
      var customRowActionRender = customRowAction && this.renderCustomRowAction();
      if (customRowActionRender && customRowActionRender.length === 0) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "editable-cell"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "colorblock"
      }, formatter ? formatter(cell, row) : cell, /*#__PURE__*/_react.default.createElement("div", {
        className: "custom-action-button-group"
      }, customRowActionRender || /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: this.onEdit,
        className: "row-edit-btn no-background-btn"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "".concat(icon)
      })))));
    }
  }]);
  return EditableCell;
}(_react.PureComponent);
EditableCell.propTypes = {
  cell: _propTypes.default.element,
  formatter: _propTypes.default.func,
  row: _propTypes.default.shape({
    rowType: _propTypes.default.string,
    isAbleUpdate: _propTypes.default.bool
  }).isRequired,
  onEdit: _propTypes.default.func.isRequired,
  listMode: _propTypes.default.shape({
    EDIT: _propTypes.default.string,
    VIEW: _propTypes.default.string
  }),
  customRowAction: _propTypes.default.shape({
    duplicateRow: _propTypes.default.arrayOf({}),
    errorRow: _propTypes.default.arrayOf({}),
    /* defaultAction is empty array or array of buttons */
    defaultAction: _propTypes.default.arrayOf({})
  })
};
EditableCell.defaultProps = {
  cell: null,
  formatter: function formatter(cell) {
    return cell;
  },
  listMode: {
    EDIT: 'Edit',
    VIEW: 'View'
  },
  customRowAction: null
};
var _default = EditableCell;
exports.default = _default;